import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { SaveDataService } from '@app/shared/services/save-data.service';

import { validateDni, validateExpirationNif } from '@app/shared/validators/dni.validator';
import { CoreModule } from '@app/core/core.module';
import { AppService } from '@app/app.service';
import { CalendarModule } from 'angular-calendar';

@Component({
    selector: 'app-identification',
    standalone: true,
    imports: [CoreModule, CommonModule, SharedModule, TranslateModule],
    templateUrl: './identification.component.html',
    styleUrl: './identification.component.scss',
})
export class IdentificationComponent {

    private saveDataService = inject(SaveDataService);
	private appData = inject(AppService);

    continueButton = 'common.buttons.continueButton';
    backButton = 'common.buttons.backButton';

    identificationTitle = 'features.identification.identificationTitle';
    identificationSubtitle = 'features.identification.identificationSubtitle';
    expirationNifLabel = 'features.identification.expirationNifLabel';


    dni = 'features.identification.dni';
    infoDni = 'features.identification.infoDni';

    backButtonDisabled = false;
    continueButtonDisabled = true;

    isPortraitDevice = false;

    formGroup!: FormGroup;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        //private saveDataService: SaveDataService,
        private changeStepService: ChangeStepService,
        private fb: FormBuilder,
    ) {
        this.changeStepService.changeStep(2);
    }

    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });

        this.createForm();
        this.setValuesForm(this.appData.data.userData.identification);

        this.formIsValid();
    }

    createForm() {
        /*
        //-DELETE
        //Ejemplo validador DNI y correo
        https://stackblitz.com/edit/reactive-forms-angular7?file=src%2Fapp%2Fapp.component.ts,src%2Fapp%2Fapp.module.ts,src%2Fapp%2Fapp.component.css
      */
        this.formGroup = this.fb.group({
            dni: ['', [Validators.required, Validators.maxLength(10), validateDni]],
            expirationNif: ['', [Validators.required, validateExpirationNif]],
        });
    }

    setValuesForm(value?: any) {
        if (value != undefined) {
            this.formGroup = this.fb.group({
                dni: [value.dni ? value.dni : '', [Validators.required, Validators.maxLength(10), validateDni]],
                expirationNif: [value.expirationNif ? value.expirationNif : '', [Validators.required, validateExpirationNif]],
            });
        }
    }

    //-------------------------//
    //------EVENT METHODS------//
    //-------------------------//

    onChangeDni(event: KeyboardEvent) {
        this.formIsValid();
    }

    onChangeDate(event: CalendarModule) {
        this.formIsValid();
    }

    //-------------------------//
    //-------VALIDATION--------//
    //-------------------------//

    formIsValid() {
        this.continueButtonDisabled = !this.formGroup.valid;
    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonBack() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'identification');
        //this.router.navigate(['/main/co-holder'], { relativeTo: this.route });
        this.router.navigate(['/main/privacy-settings'], { relativeTo: this.route });
    }

    onClicButtonContinue() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'identification');
        this.router.navigate(['/main/step/personal-data-info'], { relativeTo: this.route });
    }

    ngOnDestroy() {}
}
